// JOBE-0106 follow-up: ProvenanceBlock — side-rail block #2.
//
// UI stub awaiting JOBE-0055.9 (provenance-walk view). Renders a
// Preview-pilled card matching the existing Activity / Decide-today
// mock pattern. NO fetch.

import React from 'react';

export function ProvenanceBlock() {
  return (
    <section
      className="project-home-rail-block project-home-rail-provenance card"
      data-testid="rail-provenance"
      aria-label="Provenance trace"
    >
      <header className="project-home-rail-block-header">
        <h3 className="project-home-rail-block-title">Provenance trace</h3>
        <span
          className="lane-preview-marker mono"
          data-testid="rail-provenance-preview"
        >
          preview
        </span>
      </header>
      <p className="muted project-home-rail-stub">
        Not available yet.
      </p>
    </section>
  );
}
